var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCurvedPath(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.6625 3.275H7.95572C10.0126 3.275 11.0411 3.275 11.4315 3.64442C11.7689 3.96375 11.9185 4.43416 11.8274 4.88974C11.722 5.41679 10.8823 6.01068 9.20304 7.19846L6.45946 9.13904C4.78019 10.3268 3.94054 10.9207 3.83514 11.4478C3.74403 11.9033 3.89358 12.3738 4.23104 12.6931C4.62145 13.0625 5.64989 13.0625 7.70678 13.0625H8.3375M5.3 3.275C5.3 4.39338 4.39338 5.3 3.275 5.3C2.15662 5.3 1.25 4.39338 1.25 3.275C1.25 2.15662 2.15662 1.25 3.275 1.25C4.39338 1.25 5.3 2.15662 5.3 3.275ZM14.75 12.725C14.75 13.8434 13.8434 14.75 12.725 14.75C11.6066 14.75 10.7 13.8434 10.7 12.725C10.7 11.6066 11.6066 10.7 12.725 10.7C13.8434 10.7 14.75 11.6066 14.75 12.725Z",
    stroke: "#25324B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurvedPath);
export default __webpack_public_path__ + "static/media/curved-path.ce09ee3f8e4ba246400b19f78461d1f3.svg";
export { ForwardRef as ReactComponent };